import { useNavigate } from 'react-router-dom';
import { getUserSlice, getCartSlice } from '../../context/store/store';
import { currencyValue } from '../../helpers/currencyHelper';
import { UserNav } from '../UserNav/UserNav';
import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { constants } from '../../context/constants';
import { AlertModal } from '../Modal/AlertModal';
import { clearAuthenticatedUser } from '../../context/store/userSynchronization';

const FixedNavbarMobile = () => {

    const navigator = useNavigate();
    const { items, getSubtotal } = getCartSlice();
    const { headers, role } = getUserSlice();
    const isLogged = Boolean(Object.keys(headers).length);
    const [userOptions, setUserOptions] = useState(false);
    const [alertModalShow, setAlertModalShow] = useState(false);
    const [messagesToModal, setMessagesToModal] = useState({ title: '', body: '' });

    const Shop = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M4 7h16v16H4zm4 2V5c0-2.21 1.795-4 4-4h0c2.21 0 4 1.795 4 4v4" /></svg>
        )
    }

    const Combos = () => (
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 32 32">
            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" d="M6 13h20v14H6zm-1.5 0h23M16 13v14m0-14h-5a4 4 0 1 1 3.2-6.4L16 9l1.8-2.4A4 4 0 1 1 21 13h-5" />
            <path fill="currentColor" d="m26 3 .7 1.8 1.8.7-1.8.7L26 8l-.7-1.8-1.8-.7 1.8-.7z" />
        </svg>
    );

    const repeatedStyle = "d-flex flex-column align-items-center justify-content-end";

    const Home = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m2.25 12l8.955-8.955a1.124 1.124 0 0 1 1.59 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" /></svg>
        )
    }

    const Cart = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-cart2" viewBox="0 0 16 16">
                <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l1.25 5h8.22l1.25-5zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0" />
            </svg>
        )
    }

    const Recharge = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" d="M12 3v18M8.5 7.5C8.5 6.1 9.8 5 12 5s3.5 1.1 3.5 2.5S14.2 10 12 10s-3.5 1.1-3.5 2.5S9.8 15 12 15s3.5-1.1 3.5-2.5M4 12h2m12 0h2" />
        </svg>
    );

    const onClickUserNav = () => {
        if (!isLogged) return navigator('/signin');
        setUserOptions((prevState) => !prevState);
    }

    const onCloseModal = () => {
        setAlertModalShow(false);
        navigator('/');
    }

  const signOut = () => {
        clearAuthenticatedUser();
        setAlertModalShow(true);
        setMessagesToModal({ title: constants.MODAL_TITLE_SIGNOUT, body: constants.MODAL_BODY_SIGNOUT });
    }

    const UserOptions = () => {
        return (
            <Dropdown.Menu show className='position-relative bottom-50'>
                <Dropdown.Item eventKey="1" onClick={() => navigator('/account')}>Mi cuenta</Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={() => navigator('/movements')}>Pedidos</Dropdown.Item>
                <Dropdown.Item eventKey="4" onClick={() => navigator('/recharge')}>Recargar saldo</Dropdown.Item>
                <Dropdown.Item eventKey="5" onClick={() => navigator('/recharge/historial')}>Historial de recargas</Dropdown.Item>
                {constants.CREDENTIAL_TEMPLATE_ROLES.includes(role) && (
                    <Dropdown.Item eventKey="6" onClick={() => navigator('/distribuidor/plantilla')}>Personalizar plantilla</Dropdown.Item>
                )}
                <Dropdown.Divider />
                <Dropdown.Item eventKey="3" onClick={signOut}>Cerrar sesión</Dropdown.Item>
            </Dropdown.Menu>
        )
    }

    return (
        <>

            <div
                className="bg-light fixedMenu"
                style={{ height: '9vh', width: '100dvw', zIndex: '99' }}
            >
                <div className="d-flex w-100 h-100 justify-content-around" style={{ fontSize: '0.85rem' }}>

                    <div className={repeatedStyle} onClick={() => navigator('/')}>
                        <Home />
                        <span>Inicio</span>
                    </div>

                    <div className={repeatedStyle} onClick={onClickUserNav}>
                        {userOptions && <UserOptions />}
                        <UserNav letters={false} fixedMobile={true} />
                        {!isLogged && 'Ingreso'}
                    </div>

                    {isLogged && (
                        <div className={`${repeatedStyle} mobileRechargeAction`} onClick={() => navigator('/recharge')}>
                            <Recharge />
                            <span>Recargar</span>
                        </div>
                    )}

                    <div className={repeatedStyle} onClick={() => navigator('/shop')}>
                        <Shop />
                        <span>Tienda</span>
                    </div>

                    <div className={`${repeatedStyle} mobileCombosAction`} onClick={() => navigator('/combos')}>
                        <Combos />
                        <span>Combos</span>
                    </div>

                    <div className={repeatedStyle} onClick={() => navigator('/cart')}>
                        {!!items.length &&
                            <span className="position-relative translate-middle badge rounded-pill text-bg-danger notification">
                                {items.length}
                            </span>
                        }
                        <Cart />
                        <span>{currencyValue(getSubtotal())}</span>
                    </div>
                </div>
            </div>
            <AlertModal
                show={alertModalShow}
                onHide={() => onCloseModal()}
                title={messagesToModal.title}
                bodyText={messagesToModal.body}
                closeButton={0}
                timeout={true}
            />
        </>
    )
}

export default FixedNavbarMobile;
